var AdaptiveImage = require( "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "1b89314e543aeb56a068bfb4a1965cd1.png",
    width: 79,
    height: 79
});